import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from "./order.reducer";

export const selectFeature = createFeatureSelector<State>('Order');

export const OrderSelector = {
    selectRequestProcessing: createSelector(
        selectFeature,
        (state) => state.requestProcessing
    ),
    selectGetCustomerOrderResponse: createSelector(
        selectFeature,
        (state) => state.GetCustomerOrders.response
    ),
    selectGetCustomerOrderCriteria: createSelector(
        selectFeature, (state) => state.GetCustomerOrders.criteria
    ),
    selectDeliveryStatusResponse: createSelector(
        selectFeature,
        (state) => state.DeliveryStatus.response
    ),
    selectGetItemOrderIdResponse: createSelector(
        selectFeature,
        (state) => state.GetItemOrderId.response
    ),
    selectCancelItemOrderResponse: createSelector(
        selectFeature,
        (state) => state.CancelItemOrder.response
    ),
    selectGetCustomerItemDocketStatusResponse: createSelector(
        selectFeature,
        (state) => state.GetCustomerItemDocketStatus.response
    ),
    selectGetOrderReviewResponse: createSelector(
        selectFeature,
        (state) => state.OrderReview.response
    ),
    selectGetOrderReviewCriteria: createSelector(
        selectFeature, (state) => state.OrderReview.criteria
    ),
};
